/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Controller to management Strategic Tracking
* @controller 
* # name: strategicTrackingListCtrl
* # alias: trackCtrl
* 1: Vista por Profesor (Realiza Pland de Trabajo)
* 2: Docente
* 3: Gestion Académica
* 4: Extencion y Visibilidad
* 5: Consolidacion de Cuerpo P.
* 6: Investigacion
*/

export default class strategicTrackingListCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv, moment, GlobalConfig, $cookies) {
		this.$scope = $scope;
		this.$state = $state;
		this.moment = moment;
		this.$timeout = $timeout;
		this.ngNotify = ngNotify;
		this.$cookies = $cookies;
		this.$stateParams = $stateParams;
		this.services = strategicTrackingListSrv;
		this.userinfo = null;
		this.chartConfig = [];
		this.GlobalConfig = GlobalConfig;
		this.globalChartConfig = {};
		this.academicUnits = [];
		this.role = null;
		this.showSelect = false;
		this.idsSubmodule = '2,6,4,5,3'.split(',');
		this.columnColors = "#433275,#3ab6ce,#45739d,#bd2f71,#4082b9".split(',');
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				this.userinfo = details.user;
				this.userinfo.role_id = this.$cookies.get('hasRoleId');
				if (this.userinfo.role_id!=13 && this.userinfo.role_id!=8 && this.userinfo.role_id!=18 && this.userinfo.role_id!=29){
					this.$state.go('app.unauthorized');
				}
				if (this.userinfo.role_id != 13) {
					this.idsSubmodule.push(0);
				}
				this.main();
			}
		});
	}

	main() {
		this.checkRole();
	}

	checkRole() {
		this.services.get.typeRole({roleId: this.userinfo.role_id}).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.role = response.data[0];
				//cambio luis A 18-05-2017
				//solo pueden ingresar los roles por id:
				// - 13 --> profesor
				// - 8 --> es jefe aprobador
				// - 18 --> consultor
				if (this.role.id_code != 13) {//solo != profesor puede cambiar de ua
					this.showSelect = true;
				} else {
					this.showSelect = false;
				}
				this.getAcademicUnit();
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getCharts(acaUnit) {
		for (let i in this.idsSubmodule) {
			if (this.chartConfig[i] !== undefined) {
				this.chartConfig[i].series = [];
				this.chartConfig[i].loading = true;
			}
			let params = {
				idModule: this.idsSubmodule[i],
				idAcaUnit: acaUnit,
				userId: this.userinfo.id,
				roleId: this.userinfo.role_id,
				stateId: 0, 
				planId: 0
			}
			if (params.idModule != 0) {
				this.getDataChart(params, i);
			} else {
				this.getDataChartTotal(params, i);
			}
		}
	}

	getDataChart(params, index) {
		this.services.data.getDataChart(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Error al conectar con el servicio', 'warn');
			} else {
				this.buildCharts(response.data, index, params);
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getDataChartTotal(params, index) {
		this.services.chart.getDataChartTotal(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Error al conectar con el servicio', 'warn');
			} else {
				this.buildCharts(response.data, index, params);
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getAcademicUnit() {
		this.services.list.getAcademicUnit().$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.academicUnits = response.data;
				this.academicUnit = {id_code: 0, ds_name: "Todas"}
				this.academicUnits.unshift(this.academicUnit);
				this.getCharts(0);
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	onChangeAcaUnit() {
		if (this.academicUnit === undefined && this.academicUnit == null) {
			this.academicUnit = {id_code: 0, ds_name: "Todas"}
		}
		this.getCharts(this.academicUnit.id_code);
	}
	detectColor(nombre) {
		if(nombre == 'Vista General'){
			return 'background-color:#d0e1e1';
		}else{
			return 'background-color:#FFFFFF';
		}
	}
	buildCharts(data, index, item) {
		let conf = {
			options: {
					chart: {type: "column", backgroundColor:  data.nombre == 'Vista General'? '#d0e1e1': '#FFFFFF' }, 
					legend: {enabled: true },					 
			},
			series: [],
			title: {text: data.nombre || 'Vista general',
					style: {color: '#4f73d9',font: '18px Arial'},					
			},
			xAxis: {
				title: {text: ''},
				labels:{enabled: false}
			}, 
			yAxis: {title: {text: ""} },
			loading: false,
			size: {height: "310", },
			item: item, 

		}

		for (let x in data.state) {
			conf.series.push({
				data: [data.state[x].cantidad],
				name: data.state[x].ds_name,
				borderRadius: "5", 
        		color: this.columnColors[x],
			});
		}
		this.chartConfig[index] = conf;
	}

	onClickChart(chart) {
		let params = {
			idModule: chart.item.idModule, 
			acaUnit: chart.item.idAcaUnit
		}
		let urls = {
			"2": "strategicTracking.strategicTrackingTeacher", 
			"3": "strategicTracking.strategicTrackingAcadManagement", 
			"4": "strategicTracking.strategicTrackingExtension", 
			"5": "strategicTracking.strategicTrackingConsolidation", 
			"6": "strategicTracking.strategicTrackingInvestigation", 
			"0": "strategicTracking.strategicTrackingGlobalView", 
		}

		if (this.role.types == 'TEACHER') {
			this.goToDetails(params);
		} else {
			this.$state.go(urls[chart.item.idModule], params);
		}
	}

	goToDetails(item) {
		if (this.userinfo.role_id == 13 && item.idModule == '0') {
			return
		}
		let params = {};
		let urls = {
			"2": "strategicTracking.strategicTrackingTeacherDetails", 
			"3": "strategicTracking.strategicTrackingAcadManagementDetails", 
			"4": "strategicTracking.strategicTrackingExtensionDetails", 
			"5": "strategicTracking.strategicTrackingConsolidationDetails", 
			"6": "strategicTracking.strategicTrackingInvestigationDetails", 
			"0": "strategicTracking.strategicTrackingGlobalViewDetails", 
		}
		
		params.teacherId = JSON.parse(this.$cookies.get('currentUser')).teacherId;
		params.acaUnit = item.acaUnit;
		params.userId = this.userinfo.id;
		params.roleId = this.userinfo.role_id;
		
		this.$state.go(urls[item.idModule], params);
	}

}

strategicTrackingListCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv', 'moment', 'GlobalConfig', '$cookies'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/list/strategicTrackingListCtrl.js